let _this;
export default {
  name: "previewPDF",
  props:['previewInfo'],
  data(){
    return{

    }
  },
  mounted() {
    _this = this;
  },

  methods:{

  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/previewIncidentPDF.js